import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router preserves scroll position across navigations, which can drop
// you partway down a freshly-rendered page. Reset to the top on every path
// change. `behavior: "instant"` overrides the global smooth scroll so the
// new page appears at the top immediately rather than animating up.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
